export enum suggestionEnum {
    Calendar = 1,
    AppointmentType = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/components/suggestion-panel/suggestion-enum/suggestionEnum.ts